export default "__VITE_ASSET__BZIkTkxN__"